<script lang="ts" setup>
  import { cn } from "@/lib/utils"
  import {
    StepperTrigger,
    useForwardProps,
    type StepperTriggerProps,
  } from "reka-ui"
  import { computed, type HTMLAttributes } from "vue"

  const props = defineProps<
    StepperTriggerProps & { class?: HTMLAttributes["class"] }
  >()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })

  const forwarded = useForwardProps(delegatedProps)
</script>

<template>
  <StepperTrigger
    v-bind="forwarded"
    :class="
      cn('flex flex-col items-center rounded-md text-center', props.class)
    "
  >
    <slot />
  </StepperTrigger>
</template>
